import { Build, getAssetPath } from '@stencil/core';

export const getAssetByPath = (fileName: string) => {
  return getAssetPath(Build.isDev ? fileName : `/dist/carpentry/${fileName}`);
};
